import i18n from 'i18next';

export default () => ({
  video_source: {
    type: 'Select',
    label: i18n.t('video-source'),
    help: i18n.t('video-source-label'),
    isFluid: true,
    selectProps: {
      placeholder: i18n.t('video-source-placeholder'),
      noOptionsMessage: () => i18n.t('video-source-empty'),
    },
    options: [{
      id: 1,
      value: 'upload',
      label: 'Upload',
    }, {
      id: 2,
      label: 'URL',
      value: 'url',
    }],
    validators: [{ type: 'isRequired' }],
  },
  url: {
    type: 'Upload',
    label: i18n.t('upload-video'),
    help: i18n.t('upload-video-help'),
    uploadType: 'video',
    maxUploadSize: 3000,
    hasReplaceUploadButton: true,
    replaceUploadButtonText: i18n.t('replace-video'),
    uploadButtonText: i18n.t('upload-file'),
    removeButtonText: i18n.t('remove-video'),
    validators: [{ type: 'isRequiredIfVisible' }],
    conditions: [{ type: 'videos:isVideoSourceUpload', shouldHideField: true }],
    permittedFormats: 'video/*',
  },
  external_url: {
    type: 'Text',
    label: i18n.t('video-url'),
    help: i18n.t('video-url-help'),
    validators: [{ type: 'isRequiredIfVisible' }],
    conditions: [{ type: 'videos:isVideoSourceURL', shouldHideField: true }],
  },
});
